<template>
	<table :id="listId" class="table" :class="listClass">
		<thead>
			<tr>
				<th>
					{{ $t('MAIN_CONTENT.classPage.AssignmentsList.classPage_assignmentName') }}
				</th>
				<th>
					{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_points') }}
				</th>
				<th>
					{{ $t('MAIN_CONTENT.classPage.AssignmentsList.classPage_dueDate') }}
				</th>
				<th>
					{{ $t('MAIN_CONTENT.classPage.AssignmentsList.classPage_action') }}
				</th>
			<tr/>
		</thead>

		<tbody>
			<tr v-for="( item, itemIdx ) in listData" :key="itemIdx">
				<td>
					<strong>{{ item.NAME }}</strong><br/>
					<span v-if="item.COURSE_TITLE">{{ item.COURSE_TITLE }}</span>
					<span v-if="item.COURSE_SECTION_TITLE">{{ item.COURSE_SECTION_TITLE }}</span>
				</td>
				<td>
					<span v-if="item.POINTS">
						{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_pointsWithPoints', { points: item.POINTS } ) }}
					</span> 
				</td>
				<td>
						<span v-if="item.END_DATE" :class="'badge due-' + getDueStatus( item.END_DATE )">
							<strong> {{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_due') }}</strong> {{ formatDate( item.END_DATE ) }} 
						</span>
						<span v-else class="badge badge-secondary due-none">
							{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_noDueDate') }}
						</span>
				</td>
				<td>
					<button class="btn btn-primary" v-if="role === 'student' && item.TEST_RID && item.TEST_ENDED_FLG !== 'Y'" @click="openTest(item)">
						<span>{{ $t('MAIN_CONTENT.AssignmentsCarousel.takeTestText') }}</span><br/>
					</button>
					<button class="btn btn-primary" v-else-if="item.GRADING_COMPLETE_FLG === 'Y'" @click="reviewTest(item)">
						<span>{{ $t('MAIN_CONTENT.AssignmentsCarousel.reviewTestText') }}</span><br/>
					</button>
					<button 
						class="btn btn-primary"
						@click="openDropboxAssignment(item)"
						v-else-if="item.DROPBOX_ASSIGNMENT_ID"
					>
						<span>{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_uploadSubmission') }}</span><br/>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script type="application/javascript">
	import moment from "moment"
	import { mapGetters } from 'vuex';
	import LogClassPageActivityResource from '../../api/ClassPageLog';

	export default {
		props: {
			listId: { 				// unique grid Id
					type: String,
					required: true
			},
			listClass: {			// grid class
				type: String
			},
			listData: {
				type: Array
			},
			showCourse: {
				type: Boolean,
				default: true
			},
			colorVariant: {
				type: String,
				default: 'blank'
			}
		},
		data() {
			return {
				isLoading: false
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'role'])
		},
		methods: {
			formatDate( date ){
				return moment( date ).format( 'MM/DD/YYYY' );
			},
			getDueStatus( date ){
				if( moment( this.formatDate(date) ).isSameOrBefore( moment( moment().format('MM/DD/YYYY') ).add( 1, 'day' ) ) ){
					return 'danger';
				} else if ( moment( this.formatDate(date) ).isBetween( moment(moment().format('MM/DD/YYYY')).add( 1, 'day' ), moment(moment().format('MM/DD/YYYY')).add( 7, 'day' ), '', '(]') ){
					return 'warning';
				} else {
					return 'info';
				}
			},
			getTime( date ){
				return moment( date ).format( 'h:mm:ss A' );
			},
			openDropboxAssignment(assignment){
				this.logClassPageActivity(assignment);

				const viewsMap = {
					"C": "ClassPageAssignmentBinSubmission",
					"G": "ClassPageGroupAssignmentBinSubmission",
					"S": "ClassPageStudentAssignmentBinSubmission",
					"P": "ClassPageSectionAssignmentBinSubmission"
				};
				const view = viewsMap[assignment.DROPBOX.FOLDER_TYPE ? assignment.DROPBOX.FOLDER_TYPE : "C"];

				let params = {
					courseSectionGUID: !!assignment.COURSE_SECTION_GUID ? assignment.COURSE_SECTION_GUID : this.$route.params.courseSectionGUID,
					studentRid: this.selectedStudent.STUDENT_RID,
					assignmentBinId: assignment.DROPBOX.LINE_NO,
					assignmentId: assignment.DROPBOX_ASSIGNMENT_ID,
					folderId: assignment.DROPBOX.FOLDER_ID,
				};
 
				if( assignment.DROPBOX.FOLDER_TYPE === 'G' ){
					params.groupId = assignment.DROPBOX.FOLDER_ID;
				}

				if( assignment.DROPBOX.FOLDER_TYPE === 'S'){
					params.studentRid = this.selectedStudent.STUDENT_RID;
				}

				this.$router.push({
					name: view, 
					params: params,
				});
			},
			openTest(test){
				let routeData = this.$router.resolve({
					name: "testTaker", 
					params: {
						testRid: test.TEST_RID
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						school_id: test.SCHOOL_ID,
						course_id: test.COURSE_ID,
						section_id: test.SECTION_ID,
						teacher_rid: test.TEACHER_RID
					}
				});
				window.open(routeData.href, '_blank');
				
			},
			reviewTest(test){
				let routeData = this.$router.resolve({
					name: "testReviewer", 
					params: {
						testRid: test.TEST_RID
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						school_id: test.SCHOOL_ID,
						course_id: test.COURSE_ID,
						section_id: test.SECTION_ID,
						teacher_rid: test.TEACHER_RID
					}
				});
				window.open(routeData.href, '_blank');
			},
			logClassPageActivity(item){
				const logClassPageActivity = new LogClassPageActivityResource({
					routeParams: {
						courseSectionGuid: !!item.COURSE_SECTION_GUID ? item.COURSE_SECTION_GUID : this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					data: {
						folder_type: item.DROPBOX.FOLDER_TYPE,
						line_no: item.DROPBOX.LINE_NO
					},
				});

				logClassPageActivity.post();
			},
		}
	}
</script>
